<template>
  <v-dialog max-width="500" :model-value="isVisible" persistent>
    <v-card :title="`Subscription info for ${subscriptionInfo?.user?.payerUser?.email}`">
      <v-card-text>
        <v-table
          height="300px"
          fixed-header
        >
          <tbody>
            <tr>
              <td>Plan</td>
              <td>NuBuilder {{ selectedPlan?.name }}</td>
            </tr>
            <tr>
              <td>Status</td>
              <td>{{ activeSubscription?.subscriptionDetails?.status }}</td>
            </tr>
            <tr v-if="activeSubscription?.subscriptionDetails?.status !== 'canceled'">
              <td>Seats count</td>
              <td>{{ activeSubscription?.subscriptionDetails?.quantity }}</td>
            </tr>
            <tr v-if="!isEnterpriseUser && activeSubscription?.subscriptionDetails?.status !== 'canceled'">
              <td>Details</td>
              <td>
                <span
                  v-if="!!activeSubscription?.subscriptionDetails?.cancelAt && !activeSubscription?.scheduleSubscriptionDetails">
                  Subscription will expire on {{ nextBillingDate }}.
                </span>
                <span v-else>
                  <template v-if="!!scheduledPlan">
                    Next bill will be for the {{
                      scheduledPlan.name
                    }} plan and is scheduled for {{
                      scheduledNextBillingDate
                    }}. The payment of ${{
                      scheduledNextBillingAmount
                    }} will be charged to card ending in **** {{
                      activeSubscription?.subscriptionDetails?.cardDetails?.lastFour
                    }}.
                  </template>
                  <template v-else>
                    Next bill is ${{ activeSubscription?.subscriptionDetails?.nextBillingAmount }}
                    on {{
                      nextBillingDate
                    }}. Card ending in **** {{ activeSubscription?.subscriptionDetails?.cardDetails?.lastFour }} will be charged.
                  </template>
                </span>
              </td>
            </tr>
            <tr v-if="activeSubscription?.subscriptionDetails?.status !== 'canceled'">
              <td>Cancel date</td>
              <td>{{ activeSubscription?.subscriptionDetails?.cancelAt || "N/A" }}</td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded="lg" size="large" variant="outlined" color="gray" @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import format from 'date-fns/format'
import { ENTERPRISE_PLAN, getPlanByPriceId, getSubscriptionTypeByPriceId } from '@/utils/payments'

export default {
  name: 'AdminSubscriptionInfoDialog',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    subscriptionInfo: {
      type: Object,
      required: true
    }
  },
  emits: ['close'],
  methods: {
    close () {
      this.$emit('close')
    }
  },
  computed: {
    activeSubscription () {
      return this.subscriptionInfo?.info
    },
    isEnterpriseUser () {
      return !!this.activeSubscription && this.activeSubscription?.subscriptionDetails?.subscriptionId?.startsWith('ecus_')
    },
    selectedPlan: function () {
      if (this.activeSubscription) {
        if (this.isEnterpriseUser) {
          return ENTERPRISE_PLAN
        }
        return getPlanByPriceId(this.activeSubscription?.subscriptionDetails?.price?.id)
      }
      return null
    },
    subscriptionType: function () {
      if (this.activeSubscription) {
        return getSubscriptionTypeByPriceId(this.activeSubscription?.subscriptionDetails?.price?.id)
      }
      return null
    },
    nextBillingDate: function () {
      const nextBillingDate = this.activeSubscription?.subscriptionDetails?.nextBillingDate
      if (nextBillingDate) {
        return format(new Date(nextBillingDate), 'MMMM dd, yyyy')
      }
      return ''
    },
    scheduledNextBillingDate: function () {
      const startDate = this.activeSubscription?.scheduleSubscriptionDetails?.phases?.[0]?.startDate
      if (startDate) {
        return format(new Date(startDate), 'MMMM dd, yyyy')
      }
      return ''
    },
    scheduledPlan: function () {
      const scheduledPriceId = this.activeSubscription?.scheduleSubscriptionDetails?.phases?.[0]?.items?.[0]?.priceId
      if (scheduledPriceId) {
        return getPlanByPriceId(scheduledPriceId)
      }
      return null
    },
    scheduledNextBillingAmount: function () {
      const scheduleQuantity = this.activeSubscription?.scheduleSubscriptionDetails?.phases?.[0]?.items?.[0]?.quantity
      if (this.scheduledPlan) {
        const subscriptionType = this.scheduledSubscriptionType
        return scheduleQuantity * (subscriptionType === 'monthly' ? this.scheduledPlan.monthlyPrice : this.scheduledPlan.yearlyPrice)
      }
      return null
    }
  }
}
</script>
